const BK_MDM_AUTH_KEY = "57b2a9ba-4428-48e4-b137-f8337b68595e";
const DEFAULT_MDM_AUTH_KEY = "e3f49b87-3a1d-4c29-9c51-2f1b8f4c7ad3";

const BK_MERCHANTS = new Set(["BK", "CM", "WA"]);
const BK_MDM_AUTH_EMAILS = new Set([
  "bkadmin@erp.astrophant.online",
  "chengmengadmin@chengmeng.com.tw",
  "watsonsadmin@watsons.com.tw",
]);

export function getMdmAuthKeyByMerchant(merchantId) {
  const id = typeof merchantId === "string" ? merchantId.trim().toUpperCase() : "";
  return BK_MERCHANTS.has(id) ? BK_MDM_AUTH_KEY : DEFAULT_MDM_AUTH_KEY;
}

export function getMdmAuthKeyByEmail(email) {
  const normalizedEmail = typeof email === "string" ? email.trim().toLowerCase() : "";
  if (BK_MDM_AUTH_EMAILS.has(normalizedEmail)) {
    return BK_MDM_AUTH_KEY;
  }
  return DEFAULT_MDM_AUTH_KEY;
}
